import { apiFetchFull, api } from './client'

export interface Invoice {
  id: number
  number: string | null
  status: string
  type: string
  date: string | null
  due_date: string | null
  subtotal: string | null
  tax_amount: string | null
  total: string | null
  currency_id: string
  customer: Record<string, unknown> | null
  correction_of_id: number | null
  order_id: number | null
  finalized_at: string | null
  created_at: string
  updated_at: string
}

export interface InvoiceListParams {
  status?: string
  search?: string
  min_id?: number
  limit?: number
}

export interface InvoiceListResult {
  invoices: Invoice[]
  has_more: boolean
  next_min_id?: number
}

export async function listInvoices(params: InvoiceListParams = {}): Promise<InvoiceListResult> {
  const qs = new URLSearchParams()
  if (params.status && params.status !== 'alle') qs.set('filter[status]', params.status)
  if (params.search) qs.set('filter[q][contains]', params.search)
  if (params.min_id) qs.set('pagination[min_id]', String(params.min_id))
  qs.set('pagination[limit]', String(params.limit ?? 50))

  const res = await apiFetchFull<Invoice[]>(`/invoice/?${qs.toString()}`)
  return {
    invoices: res.data ?? [],
    has_more: res.pagination?.has_more ?? false,
    next_min_id: res.pagination?.next_min_id as number | undefined,
  }
}

export async function getInvoice(id: string): Promise<Invoice> {
  const result = await api.get<{ invoice: Invoice }>(`/invoice/${encodeURIComponent(id)}/`)
  return result.invoice
}
